var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "preview-pane" },
    [
      _c("csp-pdf-viewer", {
        ref: "pdfViewer",
        attrs: { "document-url": _vm.downloadUrl, "page-mode": "none" },
        on: {
          "page-rendered": _vm.onReRender,
          "pages-loaded": _vm.onPagesLoaded,
          "scale-changing": _vm.onReRender,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }